// extracted by mini-css-extract-plugin
module.exports = {"container":"Page_container__YmqBB","head":"Page_head__DU9k6","side":"Page_side__sorHK","body":"Page_body__bJIc4"};